<template>
  <!-- 1.all-container-start -->
  <div class="all-container">
    <!-- 订单中心->导入订单(单商品) -->
    <div class="main">
      <div class="title borderShadow">导入订单(单商品)</div>
      <div class="tips borderShadow">
        <div class="top">注意事项:</div>
        <div class="bottom">
          <div class="item">
            1.如果提示:"请对上传接口返回json字符"，请多上传两次到三次即可导入
          </div>
          <div class="item">
            2.请不要使用ie浏览器或者360兼容模式，建议使用谷歌或火狐或360极速模式
          </div>
          <div class="item">
            3.如果出现导入失败,例如
            屏幕闪动但是下方没有数据，请尝试清除excel内的格式后再导入
          </div>
          <div class="item">
            4.请仔细核查地址数据，例如有没有写区/县，或者越过地级市直接写县级市，或者写高新区之类民政部没有的区，如果对地址库有疑问，请点击下载全国最新地址库
          </div>
          <div class="item">
            5.商品sku中数量一定要用英文括号:();错误写法（）
          </div>
        </div>
      </div>
      <div class="main borderShadow">
        <div class="top flexStyle2">
          <div class="item c-animation">
            选择文件
            <input
              type="file"
              ref="referenceUpload"
              readonly="readonly"
              class="getInterOrder"
              value="导入订单"
              @change="chooseFile"
            />
          </div>
          <div class="hands item c-animation" @click="downLoadEmptyModle">
            下载空模版
          </div>
          <div class="hands item c-animation" @click="downLoadMuchGoodsModle">
            下载模版(单商品)
          </div>
          <div class="hands item c-animation" @click="resetInterInfo">
            重置导入信息
          </div>
        </div>
        <div class="bottom">
          <el-table
            :data="currentPageInfo"
            style="width: 100%"
            :header-cell-style="{
              'background-color': '#f5f5f5',
              color: 'rgb(0, 0, 0)',
              'border-bottom': '1px #d0d0d0 solid',
            }"
            @selection-change="SelectionChange"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="num" align="center" label="序号" width="65">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>

            <el-table-column prop="goodsName" label="商品名称" width="180">
              <template slot-scope="scope">
                {{ scope.row.goodsName }}
              </template>
            </el-table-column>
            <el-table-column prop="goodsSku" label="商品SKU" width="160">
              <template slot-scope="scope">
                {{ scope.row.goodsSku }}
              </template>
            </el-table-column>
            <el-table-column prop="consignee" label="联系人" width="120">
              <template slot-scope="scope">
                <span v-if="scope.row.consignee">{{
                  scope.row.consignee
                }}</span>
                <span class="error" v-else>错误联系人姓名</span>
              </template>
            </el-table-column>

            <el-table-column prop="consigneePhone" label="电话" width="120">
              <template slot-scope="scope">
                <span v-if="scope.row.consigneePhone">{{
                  scope.row.consigneePhone
                }}</span>
                <span class="error" v-else>错误联系人电话</span>
              </template>
            </el-table-column>
            <el-table-column prop="consigneeAddr" label="收货地址">
              <template slot-scope="scope">
                <span
                  v-if="
                    scope.row.province &&
                      scope.row.city &&
                      scope.row.area &&
                      scope.row.consigneeAddr
                  "
                  >{{
                    scope.row.province +
                      scope.row.city +
                      scope.row.area +
                      scope.row.consigneeAddr
                  }}</span
                >
                <span class="error" v-else>错误收货地址</span>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" width="120" />
          </el-table>
          <div class="bottom flexStyle1" v-if="currentPageInfo.length > 0">
            <div class="hands item c-animation" @click="submitInterBefore">
              确认导入
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 订单中心->导入订单(单商品) -->
  </div>
  <!-- 1.all-container-end -->
</template>

<script>
import {
  getUrl,
  exportReequest,
  upLoadOrderRequest,
  submitUpLoadOrderRequest,
} from "../../../public/js/service";

export default {
  data() {
    // 1.data
    return {
      currentPageInfo: [], // 1.1.currentPageInfo
      token: "", // 1.2.token
      fileTypes: {
        // 1.3.可上传文件类型
        accept:
          "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
    };
  },

  components: {
    // 2.components
  },

  methods: {
    // 3.methods
    getCountryAddressInfo() {
      // 3.1.都出全国地质库
      exportReequest("api/download/address/template").then((res) => {
        if (res) {
          var aLink = document.createElement("a");
          aLink.href = getUrl(res.url);
          aLink.download = "全国地址库.xls";
          aLink.style.display = "none";
          aLink.target = "_blank";
          document.body.appendChild(aLink);
          aLink.click();
          document.body.removeChild(aLink);
        }
      });
    },

    downLoadEmptyModle() {
      // 3.2.下载空模版
      exportReequest("api/download/goods/empty/template").then((res) => {
        if (res) {
          var aLink = document.createElement("a");
          aLink.href = getUrl(res.url);
          aLink.download = "无商品模版.xls";
          aLink.style.display = "none";
          aLink.target = "_blank";
          document.body.appendChild(aLink);
          aLink.click();
          document.body.removeChild(aLink);
        }
      });
    },

    chooseFile(event) {
      // 3.3.上传文件
      setTimeout(() => {
        let targetFile = event.target.files[0];
        let tff = targetFile.type;
        if (tff == "") {
          let extName = targetFile.name
            .substring(targetFile.name.lastIndexOf("."))
            .toLowerCase();
          let AllUpExt = ".xls|.xlsx|";
          if (AllUpExt.indexOf(extName + "|") == "-1") {
            this.$message.error("请选择正确格式文件！");
            this.$refs.referenceUpload.value = null;
            return false;
          }
        } else {
          if (this.fileTypes.accept.indexOf(targetFile.type) == -1) {
            this.$message.error("请选择正确格式文件！");
            this.$refs.referenceUpload.value = null;
            return false;
          }
        }

        let formData = new FormData();
        formData.append("file", targetFile, targetFile.name);
        this.openLoading();

        upLoadOrderRequest(formData).then((res) => {
          if (res) {
            this.currentPageInfo = res.data.map((item) => {
              delete item.status;
              delete item.params;
              return item;
            });
            this.closeLoading();
          }
        });
      }, 500);
    },

    submitInterBefore() {
      // 3.4.确认导入之前
      let _this = this;
      this.$msgbox({
        title: "提示",
        message: "是否确认导入?",
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        callback(res) {
          if (res == "confirm") {
            if (_this.currentPageInfo.length <= 0) {
              _this.$notify({
                title: "提示",
                message: "请选择文件后确认",
              });
            } else {
              _this.sumitInterTwoStep();
            }
          }
        },
      });
    },

    sumitInterTwoStep() {
      // 3.5.确认导入之前第二步，验证用户是否为正确导入
      let result = this.currentPageInfo.some((item) => {
        let res = Object.keys(item).some((key) => {
          if (key == "area" || key == "remark" || key == "errCode") {
            return false;
          }
          if (!item[key]) {
            console.log(key + ">>>>" + item[key]);
            return true;
          }
        });
        return res;
      });

      if (!result) {
        this.submitInter();
      } else {
        this.$notify({
          title: "提示",
          message: "当前导入订单中存在错误信息，请按照标准核实后重新导入。",
        });
      }
    },

    submitInter() {
      // 3.6.确认导入
      let data = this.currentPageInfo.map((item) => {
        delete item.goodsCount;
        return item;
      });

      this.openLoading();

      submitUpLoadOrderRequest(data).then((res) => {
        this.closeLoading();
        if (res) {
          let obj = {
            batchId: res.data.batchId,
            status: 1,
          };
          this.currentPageInfo = [];
          this.$router.push(
            "/interOrderDetail?obj=" + encodeURIComponent(JSON.stringify(obj))
          );
        }
      });
    },

    downLoadMuchGoodsModle() {
      // 3.7.下载单商品模版
      exportReequest("api/download/goods/template").then((res) => {
        if (res) {
          var aLink = document.createElement("a");
          aLink.href = getUrl(res.url);
          aLink.download = "单商品模版.xls";
          aLink.style.display = "none";
          aLink.target = "_blank";
          document.body.appendChild(aLink);
          aLink.click();
          document.body.removeChild(aLink);
        }
      });
    },

    resetInterInfo() {
      // 3.8.重置导入信息
      this.currentPageInfo = [];
      this.$emit("reset", 1);
    },

    openLoading() {
      // 3.9.打开加载遮罩层
      this.loadingInstance = this.$loading.service({
        fullscreen: true,
        lock: true,
      });
    },

    closeLoading() {
      // 3.10.关闭遮罩层
      this.loadingInstance.close();
    },

    SelectionChange() {},
  },

  mounted() {
    // 4.mounted
    if (localStorage.token) {
      this.token = localStorage.token;
    }
  },
};
</script>

<style scoped lang="scss">
$ui-width: 1350px;
@function px2vw($px) {
  @return $px / $ui-width * 100vw;
}

$mainColor1: #e65a5a;
$mainColor2: #dd3242;
$mainColor3: #ff0000;

/* 1.all-container-style-start */
.all-container {
  border-radius: px2vw(6px);
  overflow: hidden;
  box-sizing: border-box;
  padding: px2vw(2px);
  width: 100%;

  > .main {
    flex: 1;
    border-radius: px2vw(6px);
    overflow: hidden;
    box-sizing: border-box;
    padding: px2vw(2px);

    > div {
      border-radius: px2vw(6px);
      overflow: hidden;
      margin-bottom: px2vw(20px);
      overflow: hidden;
      width: 100%;
      box-sizing: border-box;
      padding: px2vw(10px) px2vw(20px);
    }

    > .title {
      font-size: 15px;
      color: #999;
      font-weight: bold;
    }

    > .tips {
      font-size: 15px;
      color: $mainColor3;

      > .bottom {
        margin-top: px2vw(4px);
        font-size: 13px;
        padding-left: 20px;
      }
    }

    > .main {
      padding-bottom: px2vw(20px);

      > .top {
        flex-wrap: wrap;
        margin: 20px 0;

        > .item {
          background-color: $mainColor1;
          color: #fff;
          border-radius: 4px;
          font-size: 13px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 14px 10px 0;
          padding: 8px 14px;
          position: relative;

          > .getInterOrder {
            width: 100%;
            height: 100%;
            opacity: 0;
            position: absolute;
            top: 0;
            left: 0;
          }
        }
      }

      > .bottom {
        > .top {
          background-color: #f5f5f5;
          border-radius: 6px;

          > .line {
            font-size: 14px;
            padding: 16px 0;
            border-bottom: 1px solid #ddd;

            &:last-child {
              border-bottom: none;
            }

            &:nth-child(1) {
              padding: px2vw(10px) 0;
              font-weight: bold;
              font-size: 15px;
            }

            > div {
              box-sizing: border-box;
              overflow: hidden;
              padding: 0 px2vw(10px);
            }

            > .id {
              width: 10%;
              text-align: center;
            }

            > .name {
              width: 15%;
              flex: 1;
              text-align: center;
            }

            > .sku {
              width: 20%;
              text-align: center;
            }

            > .people {
              width: 10%;
              text-align: center;
            }

            > .ph {
              width: 15%;
              text-align: center;
            }

            > .address {
              width: 20%;
              text-align: center;
            }

            > .note {
              width: 10%;
              text-align: center;
            }
          }
        }

        > .bottom {
          padding-top: px2vw(40px);

          > .item {
            background-color: $mainColor1;
            color: #fff;
            border-radius: 6px;
            font-size: 15px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 14px 10px 0;
            padding: 10px 80px;
          }
        }
      }
    }
  }
}
/* 1.all-container-style-start */
</style>
